import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import FlightCarrierForm from "./FlightCarrierForm";
import styles from "../showName/EditShowName.module.scss";

const AddFlightCarrier = ({ isOpen, onAdd, onCancel, setFlightCarrier }) => {
    return (
        <div>
            <Dialog open={isOpen} onClose={onCancel} fullWidth maxWidth="sm">
                <DialogTitle styles={`${styles.header} text-center`}>
                    Add flight carrier
                </DialogTitle>
                <FlightCarrierForm
                    onCancel={onCancel}
                    onAdd={onAdd}
                    setFlightCarrier={setFlightCarrier}
                />
            </Dialog>
        </div>
    )
}

export default AddFlightCarrier;
